import React from 'react'

const Footer = () => {
  return (
    <div className=' p-3 text-center text-white ' style={{backgroundColor:"teal"}}> Developed By <a className='text-decoration-none text-white' href='https://ahmedshaban022.github.io/my-portfolio/' target={"_blank"}> 𝒜ℋℳℰ𝒟 𝒮ℋ𝒜ℬ𝒜𝒩</a></div>
  )
}

export default Footer